/**
 * Image slice (SCRUM-1953, RTK bundle 4) — the former switch reducer
 * ImageReducer.js as createSlice. Behaviour-preserving: every case answers the
 * same legacy action type string (ImageTypes.js) that ImageActions.js and the
 * upload hooks already dispatch, and returns the same state. The actions module
 * is unchanged, so no importer changes.
 * Characterised by tests/integration/reducers/catalogueReducers.characterisation.test.js.
 */
import { createSlice } from "@reduxjs/toolkit";
import { legacyCases } from "../legacyCases";
import {
  QUOTE_RECEIVED,
  CLEAR_URL,
  QUOTES_RECEIVED,
  CLEAR_URLS,
  CREATE_FOLDER,
  GET_FOLDERS,
  GET_PICTURES,
  CLEAR_FOLDER,
  SET_PATH,
} from "./ImageTypes";

type ImageState = {
  url: string;
  folders: any[];
  pictures: any[];
  folder: any;
  uploadedImages: any[];
  path: string;
};

const initialState: ImageState = {
  url: "",
  folders: [],
  pictures: [],
  folder: {},
  uploadedImages: [],
  path: "",
};

const imageCases = {
  [QUOTE_RECEIVED]: "url" as const,
  [CLEAR_URL]: (state: ImageState) => ({ ...state, url: "" }),
  [QUOTES_RECEIVED]: (state: ImageState, payload: ImageState["uploadedImages"][number]) => ({
    ...state,
    uploadedImages: [...state.uploadedImages, payload],
  }),
  [CLEAR_URLS]: (state: ImageState) => ({ ...state, uploadedImages: [] }),
  [CREATE_FOLDER]: "folder" as const,
  [CLEAR_FOLDER]: (state: ImageState) => ({ ...state, folder: {} }),
  [GET_FOLDERS]: "folders" as const,
  [GET_PICTURES]: "pictures" as const,
  [SET_PATH]: "path" as const,
};

const imageSlice = createSlice({
  name: "images",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    legacyCases(builder, imageCases);
  },
});

export default imageSlice.reducer;
